// src/services/blockService.js
// 78차 42차: 신규 — 사용자 차단 기능(애플/구글 UGC 정책이 요구하는 신고/차단/연락처 3종
// 중 마지막으로 빠져 있던 것). users/{uid}.blockedUsers 배열에 본인이 직접 추가/제거하는
// 방식 — firestore.rules의 notChangingProtectedFields()에 이 필드가 없어 이미 본인
// 수정이 허용되고 있어(별도 규칙 변경 불필요) 신규 CF 없이 클라이언트에서 바로 처리.
// 차단 목록은 각자의 개인 설정이라 차단당한 쪽에는 아무 통지도 가지 않음(신고와는 별개).
import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from './firebase';

export const blockUser = (myUid, targetUid) =>
  updateDoc(doc(db, 'users', myUid), { blockedUsers: arrayUnion(targetUid) });

export const unblockUser = (myUid, targetUid) =>
  updateDoc(doc(db, 'users', myUid), { blockedUsers: arrayRemove(targetUid) });
